import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Service } from '../services';
import { Config } from '../config';
import { Layout } from '../views/Layout';

let checkAuth = false;

const Context = React.createContext();

const AuthConsumer = Context.Consumer;

class AuthProvider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      authorized: false,
    };

    this.onLogin = this.onLogin.bind(this);
    this.onLogout = this.onLogout.bind(this);
  }

  componentDidMount() {
    Service.User.Authenticated().then(response => {
      checkAuth = true;
      this.setState({
        authorized: response,
      });
    });
  }

  async onLogin(data) {
    Config.utilities.loadingAuth();

    try {
      const response = await Service.User.Login(data);
      Config.utilities.loadingAuth();
      if (response && response.token) {
        localStorage.removeItem('user');
        localStorage.setItem('user', JSON.stringify(response));

        this.setState({ authorized: true });
      } else {
        this.setState({ authorized: false });
      }
      return response;
    } catch (error) {
      this.setState({ authorized: false });
      console.log({ error });

      return error;
    }
  }

  onLogout(e) {
    e.preventDefault();

    Service.User.Logout();
    this.setState({ authorized: false });
  }

  render() {
    const { authorized } = this.state;
    const { children } = this.props;
    return (
      <Context.Provider
        value={{
          authorized,
          onLogin: this.onLogin,
          onLogout: this.onLogout,
        }}
      >
        {children}
      </Context.Provider>
    );
  }
}

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

const AuthRoute = ({ component: Component, ...rest }) => (
  <AuthConsumer>
    {({ authorized, onLogout }) => {
      let content = '';

      if (authorized) {
        content = (
          <Route
            render={props => (
              <Layout topbar footer sidebar onLogout={onLogout}>
                <Component {...props} />
              </Layout>
            )}
            {...rest}
          />
        );
      } else if (checkAuth) {
        content = <Redirect to="/login" />;
      }
      return content;
    }}
  </AuthConsumer>
);

AuthRoute.propTypes = {
  component: PropTypes.func.isRequired,
};

export { AuthConsumer, AuthProvider, AuthRoute };
